module.exports = "varying vec2 v_uv;\nuniform sampler2D textureToDisplay;\nvoid main() {\n\tgl_FragColor = texture2D(textureToDisplay, v_uv);\n}\n"